import Quill from 'quill';

const Embed = Quill.import('blots/embed');

class ChipBlot extends Embed {
  static blotName = 'chip';
  static tagName = 'span';
  static className = 'ql-chip-badge';

  static create(value) {
    const node = super.create();
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('data-chip-value', value);
    node.setAttribute('spellcheck', 'false');
    
    // Style as badge/chip
    node.style.display = 'inline-flex';
    node.style.alignItems = 'center';
    node.style.padding = '2px 10px';
    node.style.margin = '0 2px';
    node.style.borderRadius = '12px';
    node.style.backgroundColor = '#e3f2fd';
    node.style.color = '#1565c0';
    node.style.fontSize = '0.813rem';
    // font-weight / font-style / text-decoration live in index.scss (.ql-chip-badge) so a
    // wrapping <strong>/<em>/<u> can show through; an inline value here would win over it.
    node.style.cursor = 'default';
    node.style.border = '1px solid #90caf9';
    node.style.userSelect = 'none';
    node.style.verticalAlign = 'middle';
    node.style.marginBottom = '0.3rem';
    
    node.textContent = value;
    
    return node;
  }

  static value(node) {
    return node.getAttribute('data-chip-value');
  }
  
  // Make it non-deletable except with backspace
  length() {
    return 1;
  }
}

Quill.register(ChipBlot);

export default ChipBlot;
